<mat-card>
  <app-card-header
    icono="power_settings_new"
    [title]="title ?? ''"
    [subtitle]="nombreDispositivo"
    [tono]="isDispositivoDesactivado ? 'primario' : 'peligro'"
    [botonCerrar]="true"
    (cerrar)="volver()"
  ></app-card-header>

  @if (form) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <mat-card-content class="card-content-crear">
        <!-- Aviso -->
        <section class="inputs-group">
          @if (!isDispositivoDesactivado) {
            <app-info-banner
              icon="info"
              [closable]="false"
              message="Mientras dure, <strong>los eventos no serán atendibles</strong>: pasan directamente al histórico sin generar notificaciones. Sirve para mantenimientos o períodos sin monitoreo."
              margin="0"
              style="width: 100%"
            ></app-info-banner>
          } @else {
            <app-info-banner
              icon="warning"
              color="orange"
              [closable]="false"
              message="El dispositivo está desactivado: <strong>sus eventos no se atienden</strong> y van directamente al histórico. Abajo se muestra la configuración actual."
              margin="0"
              style="width: 100%"
            ></app-info-banner>
          }
        </section>

        <!-- Período de desactivación -->
        <app-content-card title="Período de desactivación" icon="schedule">
          <section class="inputs-group">
            <div class="opcion">
              <mat-checkbox color="primary" formControlName="permanente">
                Permanente
              </mat-checkbox>
              <small class="ayuda">
                La desactivación no tiene fecha de fin
              </small>
            </div>
          </section>

          @if (!form.value.permanente) {
            <section class="inputs-group">
              <div style="flex: 1" [class.disabled]="isDispositivoDesactivado">
                <app-date-range-selector
                  [(dateRange)]="range"
                  [maxDate]="null"
                  [placeholder]="'Período de tiempo específico'"
                  [noHint]="true"
                ></app-date-range-selector>
                @if (!isDispositivoDesactivado) {
                  <small class="ayuda">
                    Rango de fechas durante el cual estará desactivado
                  </small>
                }
              </div>
            </section>
          }
        </app-content-card>

        <!-- Eventos a desactivar -->
        <app-content-card title="Eventos a desactivar" icon="event_note">
          <section class="inputs-group">
            <div class="opcion">
              <mat-checkbox
                color="primary"
                [(ngModel)]="todosLosEventos"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="isDispositivoDesactivado"
              >
                Todos los eventos
              </mat-checkbox>
              <small class="ayuda">
                @if (!isDispositivoDesactivado) {
                  Desactiva todos los eventos del dispositivo
                } @else if (todosLosEventos) {
                  Todos los eventos están desactivados
                } @else {
                  Se desactivan eventos específicos
                }
              </small>
            </div>
          </section>

          @if (!todosLosEventos) {
            <!-- Códigos -->
            <section class="inputs-group">
              <div style="flex: 1; min-width: 0">
                <ng-select
                  formControlName="codigos"
                  [items]="codigos ?? []"
                  bindValue="codigo"
                  placeholder="Códigos a desactivar"
                  notFoundText="No hay códigos disponibles"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [searchFn]="searchCodigo"
                  [searchable]="true"
                  appendTo="body"
                  style="width: 100%"
                  [readonly]="isDispositivoDesactivado"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </ng-template>
                </ng-select>
                <small class="ayuda">
                  @if (!isDispositivoDesactivado) {
                    Uno o más códigos de evento a desactivar
                  } @else {
                    Códigos de evento desactivados actualmente
                  }
                </small>
              </div>
            </section>

            @if (data.alarma) {
              <!-- Particiones y zonas -->
              <section class="inputs-group">
                <div style="flex: 1; min-width: 0">
                  <ng-select
                    [(ngModel)]="particionesSeleccionadas"
                    [ngModelOptions]="{ standalone: true }"
                    [items]="particionesDisponibles"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    placeholder="Particiones a desactivar"
                    notFoundText="No hay particiones disponibles"
                    [searchable]="true"
                    appendTo="body"
                    style="width: 100%"
                    [readonly]="isDispositivoDesactivado"
                    [disabled]="isDispositivoDesactivado"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      Partición {{ item }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      Partición {{ item }}
                    </ng-template>
                  </ng-select>
                  <small class="ayuda">
                    @if (!isDispositivoDesactivado) {
                      Particiones que querés desactivar
                    } @else {
                      Particiones desactivadas actualmente
                    }
                  </small>
                </div>

                <div style="flex: 1; min-width: 0">
                  <ng-select
                    [(ngModel)]="zonasSeleccionadas"
                    [ngModelOptions]="{ standalone: true }"
                    [items]="infoZonas"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    placeholder="Zonas a desactivar"
                    notFoundText="No hay zonas disponibles"
                    [searchFn]="searchZona"
                    [searchable]="true"
                    appendTo="body"
                    style="width: 100%"
                    [readonly]="isDispositivoDesactivado"
                    [disabled]="isDispositivoDesactivado"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.nombre }} - {{ item.particion }} -
                      {{ item.zona }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.nombre }} - {{ item.particion }} -
                      {{ item.zona }}
                    </ng-template>
                  </ng-select>
                  <small class="ayuda">
                    @if (!isDispositivoDesactivado) {
                      Zonas que querés desactivar
                    } @else {
                      Zonas desactivadas actualmente
                    }
                  </small>
                </div>
              </section>
            }
          }
        </app-content-card>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="volver()">
          Cancelar
        </button>
        @if (!isDispositivoDesactivado) {
          <button
            irxBoton="peligro"
            type="submit"
            [disabled]="!form.valid || loading"
          >
            <mat-icon>do_not_disturb_on</mat-icon>
            Desactivar dispositivo
          </button>
        } @else {
          <button
            irxBoton="principal"
            type="submit"
            [disabled]="!form.valid || loading"
          >
            <mat-icon>check_circle</mat-icon>
            Reactivar dispositivo
          </button>
        }
      </mat-card-actions>
    </form>
  }
</mat-card>
